/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ToggleProductPageSyncEnabledDTO
 */
export interface ToggleProductPageSyncEnabledDTO {
  /**
   *
   * @type {boolean}
   * @memberof ToggleProductPageSyncEnabledDTO
   */
  enabled: boolean;
}

/**
 * Check if a given object implements the ToggleProductPageSyncEnabledDTO interface.
 */
export function instanceOfToggleProductPageSyncEnabledDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "enabled" in value;

  return isInstance;
}

export function ToggleProductPageSyncEnabledDTOFromJSON(json: any): ToggleProductPageSyncEnabledDTO {
  return ToggleProductPageSyncEnabledDTOFromJSONTyped(json, false);
}

export function ToggleProductPageSyncEnabledDTOFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ToggleProductPageSyncEnabledDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    enabled: json["enabled"]
  };
}

export function ToggleProductPageSyncEnabledDTOToJSON(value?: ToggleProductPageSyncEnabledDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    enabled: value.enabled
  };
}
